import { securedAxiosInstance } from "../axios";

class BusinessVerticalsService {
  fetchIndex({ enabled, page, perPage, includes, storeId } = {}) {
    return securedAxiosInstance.get("/business_verticals", {
      params: { enabled, page, per_page: perPage, includes, store_id: storeId },
    });
  }
}

export default new BusinessVerticalsService();
